var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9214 6.29413L10.9501 8.26576C11.1029 7.40975 11.0076 6.51829 10.6631 5.70764L11.4989 4.87171C12.1526 4.21816 12.1526 3.1546 11.4989 2.50097C10.8455 1.84735 9.78184 1.84735 9.12821 2.50097L6.28326 5.34592C5.62964 5.99935 5.62964 7.06303 6.28326 7.71666C6.50904 7.94247 6.78423 8.08884 7.07436 8.15817L5.55139 9.68137C5.30553 9.53165 5.0731 9.35153 4.86076 9.13907C3.42265 7.70132 3.42265 5.36142 4.86076 3.92361L7.70571 1.07867C9.14374 -0.359556 11.4835 -0.359556 12.9214 1.07867C14.3596 2.51642 14.3596 4.85632 12.9214 6.29413Z",
    fill: "#0B2EFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07867 7.70568L3.04999 5.73413C2.89704 6.59009 2.99207 7.48196 3.33665 8.29256L2.50073 9.12837C1.8471 9.78192 1.8471 10.8455 2.50073 11.4991C3.15427 12.1527 4.21783 12.1527 4.87146 11.4991L7.71669 8.65416C8.37031 8.00062 8.37031 6.93705 7.71669 6.28343C7.49069 6.05751 7.21553 5.91146 6.92559 5.84191L8.44856 4.31871C8.69453 4.46843 8.92695 4.64856 9.13907 4.86101C10.577 6.29876 10.5772 8.63855 9.13907 10.0765L6.29441 12.9214C4.85638 14.3595 2.51647 14.3595 1.07867 12.9214C-0.359556 11.4834 -0.359556 9.1436 1.07867 7.70568Z",
    fill: "#0B2EFB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.0f4cc71b.svg";
export { ForwardRef as ReactComponent };